import { NAVBAR_MENU_LIST_DEFAULTS } from '@/navbarElement/NavbarMenuList';
import { createContext, useContext } from 'react';

export interface INavbarMenuListV2Context {
  justify: string;
}

export const NavbarMenuListV2Context = createContext<INavbarMenuListV2Context>({
  justify: NAVBAR_MENU_LIST_DEFAULTS.justify,
});

export function useNavbarMenuListV2Context() {
  const context = useContext(NavbarMenuListV2Context);

  if (!context) {
    throw new Error('useNavbarMenuListV2Context must be used within a NavbarMenuList');
  }

  return context;
}
